import { FC } from 'react';

import { useElementSize, useWindowSize } from 'usehooks-ts';

import styles from './roomstay-blog-case-studies-hero.module.scss';
import ButtonBookADemo from '../ButtonBookADemo';
import ClippedBox from '../roomstay-blog-image-block/clipped-box';

export interface RoomstayBlogCaseStudiesHeroProps {
    title: string;
    description: string;
    ctaButton?: {
        text?: string;
        link?: string;
        sectionId?: string;
    }[];
}
const RoomstayBlogCaseStudiesHero: FC<RoomstayBlogCaseStudiesHeroProps> = (props) => {
    const { title, description, ctaButton } = props;

    const [ containerRef ] = useElementSize();
    const { width: windowWidth } = useWindowSize();
    const isTablet = windowWidth <= 991;

    return (
        <div ref={containerRef} className={styles.container}>
            <div className={styles.background}>
                <ClippedBox
                    customPolygon="0% 0%, 0% 100%, 100% 0%, 0% 0%"
                    configs={[]}
                    className={styles.backgroundClip}
                    style={{
                        backgroundColor: '#fff',
                        maxHeight: isTablet ? 64 : 100,
                        transform: 'rotate(180deg)',
                        marginTop: '0px',
                    }}
                />
            </div>

            <div className={styles.wrapContainer}>
                <h1 className={styles.title} dangerouslySetInnerHTML={{ __html: title }}></h1>
                <div className={styles.description} dangerouslySetInnerHTML={{ __html: description }}></div>
                <div className={styles.ctas}>
                    {ctaButton?.map((item, index) => (
                        <ButtonBookADemo key={index} className={styles.button} icon={false} iconFillColor={false} type="highty" size="default" htmlType="button" link={item?.link} sectionId={item?.sectionId}>
                            {item?.text || 'Book a Demo'}
                        </ButtonBookADemo>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default RoomstayBlogCaseStudiesHero;
